import { render, staticRenderFns } from "./telephone-collection.vue?vue&type=template&id=8461a548"
import script from "./telephone-collection.vue?vue&type=script&lang=ts"
export * from "./telephone-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports